import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { useForm } from "vee-validate";
import { watch } from "vue";
import { useI18n } from "vue-i18n";
import SelectList from "@/components/forms/SelectList.vue";
import { MilestoneReportConfig, ReportFilter } from "@/types/Report";


export default /*#__PURE__*/_defineComponent({
  __name: 'MilestoneConfig',
  props: {
    config: {},
    filters: {}
  },
  emits: ["configChange"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

const { t } = useI18n();
const { defineField } = useForm();

const [mode] = defineField("mode");

const modes = [
  { value: "sequence", name: t("analytics.reports.sequence_mode") },
  { value: "end_date", name: t("analytics.reports.end_date_mode") },
];

watch(
  () => props.config,
  () => {
    mode.value = props.config.mode;
  },
  { immediate: true },
);

const handleConfigChange = () => {
  const config: MilestoneReportConfig = {
    mode: mode.value,
  };
  emit("configChange", config);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SelectList, {
    options: modes,
    name: "mode",
    defaultSelected: _unref(mode),
    label: _unref(t)('analytics.reports.modes'),
    class: "mb-3",
    "onUpdate:selected": (value) => (mode.value = value, handleConfigChange()) 
  }, null, 8, ["defaultSelected", "label", "onUpdate:selected"]))
}
}

})